import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutosizeModule } from 'ngx-autosize';

import { MarkdownModule } from '@app/markdown/markdown.module';
import { SoftLimitValidatorDirective } from '@app/shared/directives/soft-limit-validation.directive';
import { TrackingAreaDirective } from '@app/shared/directives/tracking-area.directive';
import { PrettyDurationPipe } from '@app/shared/pipes/pretty-duration.pipe';
import { SharedModule } from '@app/shared/shared.module';
import { UserContentModule } from '@app/user-content/user-content.module';
import { TagsModule } from '@app/tags/tags.module';
import { UploaderModule } from '@app/uploader/uploader.module';
import { ReorderModalModule } from '@app/reorder-modal/reorder-modal.module';
import { NavigationModule } from '@app/navigation/navigation.module';
import { AddBySearchModule } from '@app/search/components/add-by-search/add-by-search.module';
import { ReportingDownloadableSharedModule } from '@app/reporting/downloadable/reporting-downloadable-shared.module';

import { ReactivePathwayProviders } from '@dg/pathways-rsm';
import { ReactivePathwayServices } from '@app/pathways/services/reactive-pathway-services';
import { ReactivePathwayDeclarations } from '.';
import { TargetSharedModule } from '@app/target/target-shared.module';

@NgModule({
  declarations: [SoftLimitValidatorDirective, ...ReactivePathwayDeclarations],
  imports: [
    CommonModule,
    SharedModule,
    AutosizeModule,
    MarkdownModule,
    UserContentModule,
    TagsModule,
    AddBySearchModule,
    NavigationModule,
    UploaderModule,
    ReorderModalModule,
    ReportingDownloadableSharedModule,
    TargetSharedModule,
  ],
  exports: [],
  providers: [
    TrackingAreaDirective,
    PrettyDurationPipe,
    ...ReactivePathwayServices,
    ...ReactivePathwayProviders,
  ],
})
export class PathwayModule {}
